function getRandomUrl() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 8;
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    result = 'nonce' + result;

    // 分别获取各部分
    const { origin, pathname, search, hash } = window.location;

    // 清理 pathname 中已有的 nonce
    let cleanPathname = pathname;
    if (pathname.match(/\/nonce([a-zA-Z0-9]{8})\/?$/)) {
        // 只移除结尾的 nonce 路径（更安全）
        cleanPathname = pathname.replace(/\/nonce([a-zA-Z0-9]{8})\/?$/, '');
    }

    // 确保 cleanPathname 以 / 结尾
    if (!cleanPathname.endsWith('/')) {
        cleanPathname += '/';
    }

    // 构建基础 URL（不含 nonce，但含 search 和 hash）
    const normal = `${origin}${cleanPathname}${search}${hash}`;

    // 构建带新 nonce 的 URL
    const random = `${origin}${cleanPathname}${result}/${search}${hash}`;

    return {
        normal,
        random
    };
}

export default getRandomUrl;